import {absCenter} from '@xpertdox_js/xdstyle';
import {colors} from '../../defaultSettings';

export default {
  container: {
    position: 'absolute',
    // transform: 'translateY(-100%)',
    width: '50px',
    maxWidth: '80%',
    textAlign: 'right',
    right: '1px', left: 'auto',
    height: '35px',
    whiteSpace: 'normal'
  },
  innerMenu: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    transition: 'transform .25s ease-out',
    backfaceVisibility: 'hidden',
    zIndex: 4,
  },
  button: {
    background: 'none',
    position: 'relative',
    padding: 0,
    // minWidth: '32px',
    width: '50%',
    maxWidth: '25px',
    height: '100%',
    borderRadius: 0,
    fill: colors.headerIcons,
    // boxShadow: '0 1px 3px ' + colors.opacShadeLt,
    // borderLeft: '1px solid ' + colors.headerMenuBorderDrk,
    marginLeft: 0,
    verticalAlign: 'top'
  },
  buttonHov: {
    // background: colors.bg.headerMenu,
    fill: colors.highlight,
  },
  buttonAct: {
    background: colors.bg.headerHov,
    fill: colors.highlight,
  },
  buttonSvg: {
    display: 'block',
    width: '12px',
    height: 'auto',
    ...absCenter,
  },
}
